import React from "react";
import { MapPin, Phone, Mail, Calendar } from "lucide-react";
import ScrollToTopButton from "./ScrollToTopButton";

const ContactUs = () => {
  return (
    <section className="mt-[36px] py-20 bg-white text-gray-900" id="contact">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Schedule Your Visit</h2>
          <div className="w-24 h-1 bg-blue-400 mx-auto mb-6"></div>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Contact us to schedule an appointment or learn more about our services. Our team is ready to help you on your journey to better vision and mobility.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <div className="bg-white border rounded-2xl overflow-hidden shadow-xl text-gray-800">
              <div className="p-8">
                <h3 className="text-2xl font-bold mb-6">Contact Information</h3>

                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="mr-4 p-3 bg-blue-100 text-blue-600 rounded-lg">
                      <MapPin className="w-6 h-6" />
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Location</h4>
                      <p className="text-gray-600">
                      Rajdhani Complex, Pune - Satara Rd, near Shri Shankar Maharaj Math, Pune, Maharashtra 411043
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="mr-4 p-3 bg-blue-100 text-blue-600 rounded-lg">
                      <Phone className="w-6 h-6" />
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Phone</h4>
                      <p className="text-gray-600">8788061100</p>
                      <p className="text-gray-500 text-sm">Morning: 9am-10am</p>
                      <p className="text-gray-500 text-sm">Evening: 4pm-5pm</p>

                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="mr-4 p-3 bg-blue-100 text-blue-600 rounded-lg">
                      <Mail className="w-6 h-6" />
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Email</h4>
                      <p className="text-gray-600">mjn27unity@gmail.com</p>
                      <p className="text-gray-600">jmn8unity@gmail.com</p>

                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="mr-4 p-3 bg-blue-100 text-blue-600 rounded-lg">
                      <Calendar className="w-6 h-6" />
                    </div>
                    <div>
                      <h4 className="font-bold mb-1">Hours</h4>
                      <h4 className="font-bold mb-1">Eye Hospital</h4>

                      <p className="text-gray-600">
                        Monday - Saturday: 11:00 AM - 2:00 PM<br />
                        Evening: 6:00 PM - 8:00 PM<br />
                        Sunday: Closed
                      </p>
                      <h4 className="font-bold mb-1">Ortho Hospital</h4>

                      <p className="text-gray-600">
                        Monday - Friday: 11:00 AM - 1:00 PM<br />
                        Evening: 7:00 PM - 9:00 PM<br />
                        Sunday: Closed
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
          <div className="bg-white border bg-opacity-10 backdrop-blur-lg rounded-2xl overflow-hidden shadow-xl h-full">
  <iframe
    title="Clinic Location"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.127823911832!2d73.8573886!3d18.4709066!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2ebac1ac6a151%3A0x1d6c248e8405ff5f!2sUnity%20Ortho%20and%20Eye%20Hospital!5e0!3m2!1sen!2sin!4v1714648672232!5m2!1sen!2sin"
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    className="rounded-2xl w-full h-full"
  />
</div>



            
          </div>
          
        </div>
         {/* Hospital Contact Numbers Section - NEW */}
      <div className="bg-sky-900 py-8 border-t border-sky-700 mt-20">
        <div className={`container mx-auto px-6 transition-all duration-700 ease-out delay-700 ${''}`}>
          <div className="text-center mb-6">
            <h3 className="text-white text-2xl font-bold">Contact Our Hospital</h3>
            <div className="w-32 h-1 bg-white mx-auto mt-3 rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {/* Emergency Number */}
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2">
              <div className="bg-red-500 w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h4 className="text-white text-lg font-bold mb-2">Appointment</h4>
              <p className="text-gray-300 text-sm mb-3">Available 24/7 for urgent care</p>
              <a href="tel:+8788061100" className="text-white text-xl font-bold block hover:text-sky-200 transition-colors">+8788061100</a>
            </div>
            
            {/* Appointment Number */}
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2">
              <div className="bg-green-500 w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h4 className="text-white text-lg font-bold mb-2">Appointments</h4>
              <p className="text-gray-300 text-sm mb-3">Schedule your next consultation</p>
              <a href="tel:+020-24366858" className="text-white text-xl font-bold block hover:text-sky-200 transition-colors">+020-24366858</a>
            </div>
            
            {/* General Inquiries */}
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2">
              <div className="bg-blue-500 w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h4 className="text-white text-lg font-bold mb-2">Appointment</h4>
              <p className="text-gray-300 text-sm mb-3">For information and support</p>
              <a href="tel:+020-24365287" className="text-white text-xl font-bold block hover:text-sky-200 transition-colors">+020-24365287</a>
            </div>
          </div>
        </div>
      </div>
      </div>
      
      <ScrollToTopButton />
    </section>
  );
};

export default ContactUs;
